module.exports = __webpack_public_path__ + "img/hyperx-alloy-origins-preview.32e35bf2.png";